import React from 'react';

export const CheckoutSteps = ({ step, language }) => (
  <div className="flex items-center justify-center mb-8">
    <div className="flex items-center">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${step >= 1 ? 'bg-[#0F4C5C] text-white' : 'bg-gray-200 text-gray-500'}`}>
        1
      </div>
      <span className={`ml-2 font-medium ${step >= 1 ? 'text-[#0F4C5C]' : 'text-gray-500'}`}>
        {language === 'fr' ? 'Livraison' : 'Shipping'}
      </span>
    </div>
    <div className={`w-20 h-1 mx-4 ${step >= 2 ? 'bg-[#0F4C5C]' : 'bg-gray-200'}`} />
    <div className="flex items-center">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${step >= 2 ? 'bg-[#0F4C5C] text-white' : 'bg-gray-200 text-gray-500'}`}>
        2
      </div>
      <span className={`ml-2 font-medium ${step >= 2 ? 'text-[#0F4C5C]' : 'text-gray-500'}`}>
        {language === 'fr' ? 'Paiement' : 'Payment'}
      </span>
    </div>
  </div>
);
